import React, {useCallback} from 'react'

import {accountantService} from 'services'
import useUserContext from 'components/User/useUserContext'
import Filter from 'components/Filter'
import TableWithPageHeader from 'components/TableWithPageHeader'
import Detail from './Detail'
import {mainListColumns} from './columns'

const Customers = () => {
  const {user} = useUserContext()

  const [filter, setFilter] = React.useState({})

  return (
    <TableWithPageHeader
      title='Customers'
      subtitle='Here you can find all your customers'
      detail={useCallback(rowElement => <Detail user={user} filter={filter} customer={rowElement}/>, [user, filter])}
      detailCustomBttn
      columns={mainListColumns}
      service={useCallback(
        page => accountantService.getCustomers(user.accountantProfile.uuid, user.accessToken, page),
        [user])}
      exportService
      dataHandler={useCallback(({items}) => items.map(e => ({...e.user, uuidCustomer: e.uuid})), [])}
    >
      <Filter
        filter={filter}
        setFilter={setFilter}
      />
    </TableWithPageHeader>
  )
}

export default Customers
